export enum ReportType {
  salesPerBay = 'salesPerBay',
  carsPerBay = 'carsPerBay',
  averageTicket = 'averageTicket'
}
